@if (_active) {
  <kendo-window
    #mainWindow
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-6 special_col_padding" [class.col-12]="_pageState == 2 || _pageState == 4 || _currentUser.isEnterprise">
          <div class="border_sections margin-top-4">
            <!-- Main Popup Actions and Title -->
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Model 2
                  @if (canAccess(_permissionScope, 'update')) {
                    <span (click)="_edit()" [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img [src]="'/assets/menu/'+ _theme +'/edit-action-icon-grid.svg'" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess(_permissionScope, 'update') && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li
                        (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    @if (_currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li
                        class="wikiButton"
                        (click)="_onEditFields()"
                        [class.ViewModeHiddenElement]="_pageState != 2">
                        Edit Fields
                      </li>
                    }
                    <li class="wikiButton"
                      (click)="_returnAdNew()"
                      [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li class="wikiButton">Wiki</li> [class.disabled]="_deactivatedFieldsGridData?.length == 0"-->
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        (click)="_viewInactiveFields()">
                        View Inactive Fields
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button class="steps_buttons_class" kendoButton (click)="_onCancel()">
                        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                        <span>close</span>
                      </button>
                      @if (canAccess(_permissionScope, 'create')) {
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="_pageState == 4 ? true : false" (click)="_onSave('saveAndCopy')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Copy</span>
                        </button>
                      }
                      @if (canAccess(_permissionScope, 'create')) {
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="_pageState == 4 ? true : false" (click)="_onSave('saveAndNew')">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & New</span>
                          </button>
                        }
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="_pageState == 4 ? true : false" (click)="_onSave('saveAndClose')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="_pageState == 4 ? true : false" (click)="_onSave('save')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12">
                  <div class="formsMenuSeparator"></div>
                </div>
              </div>
              <!-- Popup Content -->
              <div class="row row_padding">
                <fieldset class="col-12" [class.col-6-imp]="_pageState == 2 || _pageState == 4 || _currentUser.isEnterprise">
                  <!-- LBL_SiteCode -->
                  <sites-dropdown #Kendo_Combobox_site
                    layout="form-group"
                    [forceShow]="_isMultiSiteSelected"
                    [showAllSites]="true"
                    [labelText]="$safeNavigationMigration(getLabel('LBL_SiteCode')?.currentText)"
                    formControlName="site"
                    [textField]="'code'"
                    [valueField]="'id'"
                    [class]="'newFormControlWidth' + (getLabel('LBL_SiteCode')?.isRequired ? ' bordered' : '')"
                    [required]="$safeNavigationMigration(getLabel('LBL_SiteCode')?.isRequired)"
                    [disabled]="!(getAuthByLabel('LBL_SiteCode')?.canEdit && (_pageState == 2 || _pageState == 3))">
                  </sites-dropdown>
                  <!-- Model Number -->
                  <div KendoToolTip class="form-group from_but_container special_style_formgroup margin-top-10">
                    <label for="code" class="control-label">
                      {{getLabel("LBL_ModelNumber")?.currentText}}
                    </label>
                    <input #kendo_ModelNumber
                      type="text"
                      [class.ViewModeDisabledControl]="_pageState == 1"
                      class="k-textbox writebox min-width-0 newFormControlWidth"
                      [placeholder]="'Model #'"
                      (keyup.enter)="_upcSubmitted()"
                      (keydown.Tab)="_upcSubmitted()"
                      formControlName="number"
                      [(ngModel)]="_form.controls['number'].value"
                      [formControl]="_modelNumber"
                      [attr.disabled]="(getAuthByLabel('LBL_ModelNumber')?.canEdit  && (_pageState == 2 || _pageState == 3))? null : 'disabled'"
                      [attr.required]="getLabel('LBL_ModelNumber')?.isRequired ? 'required' : null"
                      [disabled]="(getAuthByLabel('LBL_ModelNumber')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                      [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ModelNumber')?.isRequired), 'disabled': getAuthByLabel('LBL_ModelNumber')?.canEdit ? false : true}"
                      required />
                      @if (isUpcOnlineSetting) {
                        <a
                          title="UPC look-up"
                          [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                          class="cursor-pointer" (click)="_searchUPC()">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/search-icon.svg'" />
                        </a>
                      }
                      <a title="Edit {{getLabel('LBL_ModelNumber')?.currentText}}"
                        [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon" (click)="_openRenameForm('LBL_ModelNumber', true)">
                        <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                      </a>
                      <!--Barcode-->
                      @if (_pageState == 3) {
                        <app-barcode-print [page]="_page" [BarcodeValue]="_form.controls['number'].value"></app-barcode-print>
                      }
                      <!--Barcode End-->
                    </div>
                    <!-- Model Name -->
                    <div KendoToolTip class="form-group special_style_formgroup">
                      <label for="code" class="control-label">
                        {{getLabel("LBL_ModelName")?.currentText}}
                      </label>
                      <input #kendo_ModelName
                        type="text"
                        [class.ViewModeDisabledControl]="_pageState == 1"
                        class="k-textbox writebox min-width-0 newFormControlWidth"
                        [placeholder]="'Model Name'"
                        (keyup.enter)="_upcSubmitted()"
                        (keydown.Tab)="_upcSubmitted()"
                        formControlName="name"
                        [formControl]="_modelName"
                        [(ngModel)]="_form.controls['name'].value"
                        [attr.disabled]="(getAuthByLabel('LBL_ModelName')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                        [attr.required]="getLabel('LBL_ModelName')?.isRequired ? 'required' : null"
                        [required]="getLabel('LBL_ModelName')?.isRequired ? 'required' : null"
                        [disabled]="(getAuthByLabel('LBL_ModelName')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                       [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ModelName')?.isRequired),
                  'disabled': getAuthByLabel('LBL_ModelName')?.canEdit ? false : true}" />
                        <a title="Edit {{getLabel('LBL_ModelName')?.currentText}}"
                          [class.editfieldsIconvisible]="_pageState == 4"
                          class="editFieldsIcon" (click)="_openRenameForm('LBL_ModelName')">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      </div>
                      <!-- Model Type / AKA: Asset Type -->
                      <div KendoToolTip class="form-group special_style_formgroup">
                        <label for="code" class="control-label">
                          {{getLabel("LBL_AssetTypeModelType")?.currentText}}
                        </label>
                        <kendo-combobox #Kendo_Combobox_modelType
                          class="newFormControlWidth"
                          [data]="assetTypesData"
                          [suggest]="true"
                          [placeholder]=""
                          formControlName="modelType"
                          [formControl]="_modelTypeDD"
                          [textField]="'modelType'"
                          [valueField]="'id'"
                          [(ngModel)]="_form.controls['modelType'].value"
                          [attr.disabled]="_tabEnabled && (getAuthByLabel('LBL_AssetTypeModelType')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                          [attr.required]="getLabel('LBL_AssetTypeModelType')?.isRequired ? 'required' : null"
                          [required]="getLabel('LBL_AssetTypeModelType')?.isRequired ? 'required' : null"
                          [disabled]="_tabEnabled && (getAuthByLabel('LBL_AssetTypeModelType')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetTypeModelType')?.isRequired),
                  'disabled': getAuthByLabel('LBL_AssetTypeModelType')?.canEdit ? false : true}">
                        </kendo-combobox>
                        <!-- Add New Link -->
                        @if (_modelTypeAuth?.canAdd) {
                          <a
                            class="cursor-pointer"
                            (click)="_openForm('asset-types')"
                            [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                            <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                          </a>
                        }
                        <!-- Fetch / Select-->
                        <span class="asap-input-icon" [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                          <img class="addIcon" (click)="_openModelTypeList()" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                        </span>
                        <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon" (click)="_openRenameForm('LBL_AssetTypeModelType')">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      </div>
                      <!-- Model Class -->
                      <div KendoToolTip class="form-group special_style_formgroup">
                        <label for="code" class="control-label">
                          {{getLabel("LBL_ModelClass")?.currentText}}
                        </label>
                        <kendo-combobox #Kendo_Combobox_modelClass
                          class="bordered newFormControlWidth"
                          [data]="modelClassData"
                          [suggest]="true"
                          [placeholder]=""
                          formControlName="modelClass"
                          [textField]="'code'"
                          [valueField]="'id'"
                          [(ngModel)]="_form.controls['modelClass'].value"
                          [attr.disabled]="(getAuthByLabel('LBL_ModelClass')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                          [attr.required]="getLabel('LBL_ModelClass')?.isRequired ? 'required' : null"
                          [disabled]="(getAuthByLabel('LBL_ModelClass')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ModelClass')?.isRequired),
                  'disabled': getAuthByLabel('LBL_ModelClass')?.canEdit ? false : true}">
                        </kendo-combobox>
                        <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon" (click)="_openRenameForm('LBL_ModelClass')">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      </div>
                      <!-- Model Person -->
                      <div KendoToolTip class="form-group special_style_formgroup">
                        <label for="person" class="control-label">
                          {{getLabel("LBL_AssetReservationPerson")?.currentText}}
                        </label>
                        <kendo-combobox #Kendo_Combobox_person
                          class="bordered newFormControlWidth"
                          [data]="personsData"
                          [suggest]="true"
                          [placeholder]=""
                          formControlName="person"
                          [textField]="'code'"
                          [valueField]="'id'"
                          [(ngModel)]="_form.controls['person'].value"
                          [attr.disabled]="(getAuthByLabel('LBL_AssetReservationPerson')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                          [attr.required]="getLabel('LBL_AssetReservationPerson')?.isRequired ? 'required' : null"
                          [disabled]="(getAuthByLabel('LBL_AssetReservationPerson')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetReservationPerson')?.isRequired),
                  'disabled': getAuthByLabel('LBL_AssetReservationPerson')?.canEdit ? false : true}">
                        </kendo-combobox>
                        <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon" (click)="_openRenameForm('LBL_AssetReservationPerson')">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <!-- Graphs Area -->
              @if (_pageState != 2 && _pageState != 4 && !_currentUser.isEnterprise) {
                <div class="col-6 special_col_padding">
                  <div class="border_sections margin-top-4 bordered-With-charts">
                    @if ((_currentUser && _currentUser.isEnterprise)) {
                      <div
                        class="col-12 charts-container upsert-donut-chart">
                        Charts / Graphs Go Here
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <!-- Tabs and Fields -->
            <div class="example-wrapper">
              <div class="row no_row_margin">
                <div [ngClass]="{'col-md-8': !_currentUser.isEnterprise,'col-md-12':_currentUser.isEnterprise}"
                  class="responsive_style numericboxtab" [class.ossystem]="_isOs" #kendo_tabstrip_wrapper>
                  <kendo-tabstrip (tabSelect)="_onTabSelect($event)" [tabPosition]="_kendoTabStripPosition"
                    #kendo_tabstrip>
                    <!-- Accounts Tab -->
                    @if (_currentUser && _currentUser.isEnterprise) {
                      <kendo-tabstrip-tab
                        #accountTab title="Accounts"
                        [selected]="_currentUser && _currentUser.isEnterprise">
                        <ng-template kendoTabContent>
                          <div class="greytabtop menumobilecontainer">
                            <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                          </div>
                          <div class="tabcontent tabWizGridInside accountTab" [class.active]="_addClassActive">
                            <asap-account-sites-selection
                              [class.ViewModeDisabledControl]="_pageState == 1"
                              [disabled]="_pageState == 1"
                              [selectedAccounts]="_selectedAccounts"
                              [resolver]="_getAccounts"
                              (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                            </asap-account-sites-selection>
                          </div>
                        </ng-template>
                      </kendo-tabstrip-tab>
                    }
                    @for (tab of _dataTabs; track tab) {
                      <!-- General Tab -->
                      @if (tab.name == 'General') {
                        <kendo-tabstrip-tab [title]="tab.name" [disabled]="!_tabEnabled" [selected]="_currentUser && !_currentUser.isEnterprise">
                          <ng-template kendoTabContent>
                            <div class="greytabtop menumobilecontainer">
                              <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                            </div>
                            <div class="tabcontent">
                              <fieldset class="contenttabstyle">
                                <h2 class="tabcontentTitle">General</h2>
                                <!-- Tab Static Content -->
                                @if (_pageState == 4) {
                                  <kendo-sortable [kendoSortableBinding]="_systemFields"
                                    [navigable]="true"
                                    [animation]="true"
                                    class="col-12 zeroPaddingColumn"
                                    emptyItemClass="item-empty"
                                    itemClass="reordered-item col-12 zeroPaddingColumn"
                                    activeItemClass="active-reordered-item"
                                    (dataMove)="dataMove(_systemFields[$event.index], _systemFields[$event.oldIndex])"
                                    (dragEnd)="dragEnd()">
                                    <ng-template let-item="item">
                                      <!-- LBL_InfoCost control -->
                                      @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoCost') {
                                        @if (getAuthByLabel('LBL_InfoCost')?.canView) {
                                          <div
                                            KendoToolTip class="form-group special_style_formgroup">
                                            <a [class.reorderSysFieldsIcon]="_pageState == 4" class="editSystemFieldsIcon">
                                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                            </a>
                                            <a class="editSystemFieldsIcon">
                                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                            </a>
                                            <label for="infoCost" class="control-label">
                                              {{getLabel("LBL_InfoCost")?.currentText}}
                                            </label>
                                            <kendo-numerictextbox type="number"
                                              class="k-textbox writebox newFormControlWidth"
                                              formControlName="infoCost"
                                              placeholder=""
                                              [attr.disabled]="'disabled'"
                                              [attr.required]="getLabel('LBL_InfoCost')?.isRequired ? 'required' : null"
                                              [disabled]="true"
                                              [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoCost')?.isRequired), 'disabled': getAuthByLabel('LBL_InfoCost')?.canEdit ? false : true}">
                                            </kendo-numerictextbox>
                                            <a title="Edit {{getLabel('LBL_InfoCost')?.currentText}}"
                                              class="editFieldsIcon" [class.editfieldsIconvisible]="_pageState == 4"
                                              (click)="_openRenameForm('LBL_InfoCost')">
                                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                          </div>
                                        }
                                      }
                                      <!-- LBL_InfoAdditionalDescription control -->
                                      @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoAdditionalDescription') {
                                        @if (getAuthByLabel('LBL_InfoAdditionalDescription')?.canView) {
                                          <div
                                            KendoToolTip class="form-group special_style_formgroup">
                                            <a [class.reorderSysFieldsIcon]="_pageState == 4" class="editSystemFieldsIcon">
                                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                            </a>
                                            <a class="editSystemFieldsIcon">
                                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                            </a>
                                            <label for="infoAdditionalDescription" class="control-label">
                                              {{getLabel("LBL_InfoAdditionalDescription")?.currentText}}
                                            </label>
                                            <input type="text"
                                              class="k-textbox writebox newFormControlWidth"
                                              formControlName="infoAdditionalDescription"
                                              placeholder=""
                                              [attr.disabled]="'disabled'"
                                              [attr.required]="getLabel('LBL_InfoAdditionalDescription')?.isRequired ? 'required' : null"
                                              [disabled]="true"
                                         [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoAdditionalDescription')?.isRequired),
                                      'disabled': getAuthByLabel('LBL_InfoAdditionalDescription')?.canEdit ? false : true}" />
                                              <a title="Edit {{getLabel('LBL_InfoAdditionalDescription')?.currentText}}"
                                                class="editFieldsIcon"
                                                [class.editfieldsIconvisible]="_pageState == 4"
                                                (click)="_openRenameForm('LBL_InfoAdditionalDescription')">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                              </a>
                                            </div>
                                          }
                                        }
                                        <!-- LBL_InfoModelManufacturer control -->
                                        @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoModelManufacturer') {
                                          @if (getAuthByLabel('LBL_InfoModelManufacturer')?.canView) {
                                            <div
                                              KendoToolTip class="form-group special_style_formgroup">
                                              <a [class.reorderSysFieldsIcon]="_pageState == 4" class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <a class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <label for="infoModelManufacturer" class="control-label">
                                                {{getLabel("LBL_InfoModelManufacturer")?.currentText}}
                                              </label>
                                              <input type="text"
                                                class="k-textbox writebox newFormControlWidth"
                                                formControlName="infoModelManufacturer"
                                                placeholder=""
                                                [attr.disabled]="'disabled'"
                                                [attr.required]="getLabel('LBL_InfoModelManufacturer')?.isRequired ? 'required' : null"
                                                [disabled]="true"
                                         [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoModelManufacturer')?.isRequired),
                                      'disabled': getAuthByLabel('LBL_InfoModelManufacturer')?.canEdit ? false : true}" />
                                                <a title="Edit {{getLabel('LBL_InfoModelManufacturer')?.currentText}}"
                                                  class="editFieldsIcon"
                                                  [class.editfieldsIconvisible]="_pageState == 4"
                                                  (click)="_openRenameForm('LBL_InfoModelManufacturer')">
                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                                </a>
                                              </div>
                                            }
                                          }
                                          <!-- LBL_InfoCategoryId control -->
                                          @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoCategoryId') {
                                            <div class="form-group special_style_formgroup">
                                              <a [class.reorderSysFieldsIcon]="_pageState == 4" class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <label for="infoCategory" class="control-label">
                                                {{getLabel("LBL_InfoCategoryId")?.currentText}}
                                              </label>
                                              <kendo-combobox #Kendo_Combobox_infoCategory
                                                class="bordered newFormControlWidth"
                                                [data]="categoriesData"
                                                [suggest]="true"
                                                [placeholder]=""
                                                formControlName="infoCategory"
                                                [formControl]="_categoryDD"
                                                [textField]="'code'"
                                                [valueField]="'id'"
                                                [(ngModel)]="_form.controls['infoCategory'].value"
                                                [attr.disabled]="'disabled'"
                                                [attr.required]="getLabel('LBL_InfoCategoryId')?.isRequired ? 'required' : null"
                                                [disabled]="true"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoCategoryId')?.isRequired), 'disabled': getAuthByLabel('LBL_InfoCategoryId')?.canEdit ? false : true}">
                                              </kendo-combobox>
                                              <a [class.editfieldsIconvisible]="_pageState == 4"
                                                class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_InfoCategoryId')">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                              </a>
                                            </div>
                                          }
                                        </ng-template>
                                      </kendo-sortable>
                                    }
                                    @if (_pageState != 4) {
                                      @for (item of _systemFields; track item) {
                                        <!-- LBL_InfoCost control -->
                                        @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoCost') {
                                          @if (getAuthByLabel('LBL_InfoCost')?.canView) {
                                            <div
                                              KendoToolTip class="form-group special_style_formgroup">
                                              <a class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <a class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <label for="infoCost" class="control-label">
                                                {{getLabel("LBL_InfoCost")?.currentText}}
                                              </label>
                                              <kendo-numerictextbox type="text"
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                class="k-textbox writebox newFormControlWidth"
                                                formControlName="infoCost"
                                                placeholder=""
                                                [attr.disabled]="(getAuthByLabel('LBL_InfoCost')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_InfoCost')?.isRequired ? 'required' : null"
                                                [disabled]="(getAuthByLabel('LBL_InfoCost')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoCost')?.isRequired), 'disabled': getAuthByLabel('LBL_InfoCost')?.canEdit ? false : true}">
                                              </kendo-numerictextbox>
                                            </div>
                                          }
                                        }
                                        <!-- LBL_InfoAdditionalDescription control -->
                                        @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoAdditionalDescription') {
                                          @if (getAuthByLabel('LBL_InfoAdditionalDescription')?.canView) {
                                            <div
                                              KendoToolTip
                                              class="form-group special_style_formgroup">
                                              <a class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <a class="editSystemFieldsIcon">
                                                <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                              </a>
                                              <label for="infoAdditionalDescription" class="control-label">
                                                {{getLabel("LBL_InfoAdditionalDescription")?.currentText}}
                                              </label>
                                              <input type="text"
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                class="k-textbox writebox newFormControlWidth"
                                                formControlName="infoAdditionalDescription"
                                                placeholder=""
                                                [attr.disabled]="(getAuthByLabel('LBL_InfoAdditionalDescription')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_InfoAdditionalDescription')?.isRequired ? 'required' : null"
                                                [disabled]="(getAuthByLabel('LBL_InfoAdditionalDescription')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                       [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoAdditionalDescription')?.isRequired),
                                      'disabled': getAuthByLabel('LBL_InfoAdditionalDescription')?.canEdit ? false : true}" />
                                              </div>
                                            }
                                          }
                                          <!-- LBL_InfoModelManufacturer control -->
                                          @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoModelManufacturer') {
                                            @if (getAuthByLabel('LBL_InfoModelManufacturer')?.canView) {
                                              <div
                                                KendoToolTip
                                                class="form-group special_style_formgroup">
                                                <a class="editSystemFieldsIcon">
                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                                </a>
                                                <a class="editSystemFieldsIcon">
                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                                </a>
                                                <label for="infoModelManufacturer" class="control-label">
                                                  {{getLabel("LBL_InfoModelManufacturer")?.currentText}}
                                                </label>
                                                <input type="text"
                                                  [class.ViewModeDisabledControl]="_pageState == 1"
                                                  class="k-textbox writebox newFormControlWidth"
                                                  formControlName="infoModelManufacturer"
                                                  placeholder=""
                                                  [attr.disabled]="(getAuthByLabel('LBL_InfoModelManufacturer')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                                                  [attr.required]="getLabel('LBL_InfoModelManufacturer')?.isRequired ? 'required' : null"
                                                  [disabled]="(getAuthByLabel('LBL_InfoModelManufacturer')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                       [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoModelManufacturer')?.isRequired),
                                      'disabled': getAuthByLabel('LBL_InfoModelManufacturer')?.canEdit ? false : true}" />
                                                </div>
                                              }
                                            }
                                            <!-- LBL_InfoCategoryId control -->
                                            @if (item.gridFieldText?.gridFieldDefinition?.objectCode == 'LBL_InfoCategoryId') {
                                              <div class="form-group special_style_formgroup">
                                                <a class="editSystemFieldsIcon">
                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                                </a>
                                                <label for="infoCategory" class="control-label">
                                                  {{getLabel("LBL_InfoCategoryId")?.currentText}}
                                                </label>
                                                <kendo-combobox #Kendo_Combobox_infoCategory
                                                  class="bordered newFormControlWidth"
                                                  [data]="categoriesData"
                                                  [suggest]="true"
                                                  [placeholder]=""
                                                  formControlName="infoCategory"
                                                  [textField]="'code'"
                                                  [valueField]="'id'"
                                                  [(ngModel)]="_form.controls['infoCategory'].value"
                                                  [attr.disabled]="(getAuthByLabel('LBL_InfoCategoryId')?.canEdit && (_pageState == 2 || _pageState == 3)) ? null : 'disabled'"
                                                  [attr.required]="getLabel('LBL_InfoCategoryId')?.isRequired ? 'required' : null"
                                                  [disabled]="(getAuthByLabel('LBL_InfoCategoryId')?.canEdit && (_pageState == 2 || _pageState == 3)) ? false : true"
                                                  [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_InfoCategoryId')?.isRequired), 'disabled': getAuthByLabel('LBL_InfoCategoryId')?.canEdit ? false : true}">
                                                </kendo-combobox>
                                                <!-- Add New Link -->
                                                @if (_categoryAuth?.canAdd) {
                                                  <a
                                                    [class.ViewModeHiddenElement]="_pageState == 1"
                                                    class="cursor-pointer" (click)="_openForm('categories')">
                                                    <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                                  </a>
                                                }
                                                <!-- Fetch / Select-->
                                                <span class="asap-input-icon" [class.ViewModeHiddenElement]="_pageState == 1">
                                                  <img class="addIcon" (click)="_openCategoryList()" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                                </span>
                                              </div>
                                            }
                                          }
                                        }
                                        <!-- Tab Custom Fields -->
                                        <div class="tabcontent p-0">
                                          <fieldset class="contenttabstyle margin-top-10">
                                            <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                              [pageState]="_pageState"
                                              [accounts]="_selectedAccountIds"
                                              [formName]="'asset'"
                                              page="asset-models"
                                              [invalidSubmit]="_invalidSubmit"
                                              (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                              (customFieldsDeleteValue)="_removeCustomField($event)"
                                              (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                              (customFieldsStatus)="formStatus($event)"
                                              [_customFieldsValue]="_customFieldsValue">
                                            </asap-custom-fields-form>
                                          </fieldset>
                                        </div>
                                        <div class="form-group special_style_formgroup">
                                          <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                                            <span>Add New Field</span>
                                          </button>
                                        </div>
                                        <!-- <div class="form-group special_style_formgroup">
                                        <button kendobutton
                                          class="addNewFieldButton k-button"
                                          (click)="_deactivateTab(tab.id, _entity)">
                                          <img class="backimage"
                                            src="/assets/menu/enterprise/add-icon-green.svg"/>
                                            <span>Deactivate Tab</span>
                                          </button>
                                        </div> -->
                                      </fieldset>
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              @if (tab.name == 'Pictures') {
                                <kendo-tabstrip-tab [title]="tab.name" #picturesTab [disabled]="!_tabEnabled">
                                  <!-- Tab Static Content -->
                                  <ng-template kendoTabContent>
                                    <div class="greytabtop menumobilecontainer">
                                      <img class="mobiletabIcon"
                                        (click)="_mobileMenuToggle()"
                                        [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                      </div>
                                      <div class="tabcontent">
                                        <fieldset class="contenttabstyle">
                                          <h2 class="tabcontentTitle">Pictures</h2>
                                          <div class="greytabtop">
                                            <button [class.ViewModeHiddenElement]="_pageState == 1"
                                              kendoButton
                                              (click)="_openForm(_filesPageName)"
                                              class="topRightButtonSecond">
                                              Add Picture
                                            </button>
                                            <button [class.ViewModeHiddenElement]="_pageState == 1"
                                              kendoButton
                                              (click)="_selectImagesHandler($event)"
                                              class="topRightButton mr-2">
                                              Select from Library
                                            </button>
                                          </div>
                                          <div class="tabcontent tabWizGridInside"
                                            [class.ViewModeDisabledControl]="_pageState == 1">
                                            <!-- [selectable]="true" -->
                                            <asap-grid-layout [returnedSelectedKeys]="_selectedImagesKeys"
                                              [pagingEnabled]="false"
                                              [enableSiteSelection]="false"
                                              [data]="_modelFilesPics"
                                              [isData]="true"
                                              class="gridWithcontent"
                                              (onRowSelectionChanges)="_onSelectedImagesChanged($event)"
                                              (onRowObjectSelectionChanges)="_onSelectedImagesRowChanged($event)">
                                              <ng-template pageListColumn
                                                name="Name"
                                                field="file.name"
                                                let-item>
                                                {{item.file.name}}
                                              </ng-template>
                                              <ng-template pageListColumn
                                                name="Description"
                                                field="file.description"
                                                let-item>
                                                {{item.file.description}}
                                              </ng-template>
                                              <ng-template pageListColumn
                                                name="Type"
                                                field="file.type"
                                                let-item>
                                                {{item.file.type}}
                                              </ng-template>
                                              <ng-template pageListColumn name="Stream" let-item>
                                                <img src="{{_storagePath + item.file.thumbnail}}"
                                                  alt="{{ item.file.name }}"
                                                  title="{{ item.file.name }}"
                                                  width="50" />
                                                </ng-template>
                                                <ng-template pageListColumn
                                                  name="Primary"
                                                  field="modelFileisPrimary"
                                                  let-item>
                                                  <input kendoCheckBox
                                                    type="checkbox"
                                                    name="Primary"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.modelFileisPrimary"
                                                    (ngModelChange)="_setPrimaryPic(item)" />
                                                  </ng-template>
                                                  <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                    <div class="asap-grid-remove" (click)="_removePicHandler(item)" [class.ViewModeHiddenElement]="_pageState == 1">
                                                      <div class="asap-grid-remove-icon">
                                                        <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                      </div>
                                                      <div class="asap-grid-remove-text">Delete</div>
                                                    </div>
                                                  </ng-template>
                                                  <!-- <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                  <div class="asap-grid-remove" (click)="_removePicHandlerFromLibrary(item)">
                                                    <div class="asap-grid-remove-icon">
                                                      <img src="/assets/menu/enterprise/delete-from-library.svg" />
                                                    </div>
                                                    <div class="asap-grid-remove-text">Delete From Library</div>
                                                  </div>
                                                </ng-template> -->
                                              </asap-grid-layout>
                                            </div>
                                            <!-- Tab Custom Fields -->
                                            <div class="tabcontent p-0">
                                              <fieldset class="contenttabstyle margin-top-10">
                                                <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                  [pageState]="_pageState"
                                                  [accounts]="_selectedAccountIds"
                                                  [formName]="'asset'"
                                                  page="asset-models"
                                                  [invalidSubmit]="_invalidSubmit"
                                                  (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                  (customFieldsDeleteValue)="_removeCustomField($event)"
                                                  (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                  (customFieldsStatus)="formStatus($event)"
                                                  [_customFieldsValue]="_customFieldsValue">
                                                </asap-custom-fields-form>
                                              </fieldset>
                                            </div>
                                            <div class="form-group special_style_formgroup">
                                              <button kendobutton
                                                class="addNewFieldButton k-button"
                                                (click)="_addNewField(tab.id)">
                                                <img class="backimage"
                                                  src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                </button>
                                              </div>
                                            </fieldset>
                                          </div>
                                        </ng-template>
                                      </kendo-tabstrip-tab>
                                    }
                                    @if (tab.name == 'Documents') {
                                      <kendo-tabstrip-tab [title]="tab.name"
                                        [disabled]="!_tabEnabled">
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon"
                                              (click)="_mobileMenuToggle()"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle">
                                                <h2 class="tabcontentTitle">Documents</h2>
                                                <!-- Tab Static Content -->
                                                <div class="greytabtop">
                                                  <button [class.ViewModeHiddenElement]="_pageState == 1"
                                                    kendoButton
                                                    (click)="_openForm(_documentsPageName)"
                                                    class="topRightButtonSecond">
                                                    Add Documents
                                                  </button>
                                                  <button [class.ViewModeHiddenElement]="_pageState == 1"
                                                    kendoButton
                                                    (click)="_selectDocumentsHandler($event)"
                                                    class="topRightButton">
                                                    Select from Library
                                                  </button>
                                                </div>
                                                <div class="tabcontent tabWizGridInside"
                                                  [class.ViewModeDisabledControl]="_pageState == 1">
                                                  <!-- [selectable]="true" -->
                                                  <asap-grid-layout [returnedSelectedKeys]="_selectedDocumentsKeys"
                                                    [pagingEnabled]="false"
                                                    [enableSiteSelection]="false"
                                                    [data]="_modelFilesDoc"
                                                    [isData]="true"
                                                    (doubleClickEvent)="_doDownloadFile($event)"
                                                    class="gridWithcontent">
                                                    <ng-template pageListColumn
                                                      name="Name"
                                                      field="file.name"
                                                      let-item>
                                                      {{item.file.name}}
                                                    </ng-template>
                                                    <ng-template pageListColumn
                                                      name="Description"
                                                      field="file.description"
                                                      let-item>
                                                      {{item.file.description}}
                                                    </ng-template>
                                                    <ng-template pageListColumn
                                                      name="Type"
                                                      field="file.type"
                                                      let-item>
                                                      {{item.file.type}}
                                                    </ng-template>
                                                    <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                      <div class="asap-grid-remove" (click)="_removeDocHandler(item)" [class.ViewModeHiddenElement]="_pageState == 1">
                                                        <div class="asap-grid-remove-icon">
                                                          <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                        </div>
                                                        <div class="asap-grid-remove-text">Delete</div>
                                                      </div>
                                                    </ng-template>
                                                    <!-- <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                    <div class="asap-grid-remove" (click)="_removePicHandlerFromLibrary(item)">
                                                      <div class="asap-grid-remove-icon">
                                                        <img src="/assets/menu/enterprise/delete-from-library.svg" />
                                                      </div>
                                                      <div class="asap-grid-remove-text">Delete From Library</div>
                                                    </div>
                                                  </ng-template> -->
                                                </asap-grid-layout>
                                              </div>
                                              <!-- Tab Custom Fields -->
                                              <div class="tabcontent p-0">
                                                <fieldset class="contenttabstyle margin-top-10">
                                                  <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                    [pageState]="_pageState"
                                                    [accounts]="_selectedAccountIds"
                                                    [formName]="'asset'"
                                                    page="asset-models"
                                                    [invalidSubmit]="_invalidSubmit"
                                                    (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                    (customFieldsDeleteValue)="_removeCustomField($event)"
                                                    (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                    (customFieldsStatus)="formStatus($event)"
                                                    [_customFieldsValue]="_customFieldsValue">
                                                  </asap-custom-fields-form>
                                                </fieldset>
                                              </div>
                                              <div class="form-group special_style_formgroup">
                                                <button kendobutton
                                                  class="addNewFieldButton k-button"
                                                  (click)="_addNewField(tab.id)">
                                                  <img class="backimage"
                                                    src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                  </button>
                                                </div>
                                              </fieldset>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                      }
                                      @if (tab.name == 'Videos') {
                                        <kendo-tabstrip-tab [title]="tab.name"
                                          [disabled]="!_tabEnabled">
                                          <ng-template kendoTabContent>
                                            <div class="greytabtop menumobilecontainer">
                                              <img class="mobiletabIcon"
                                                (click)="_mobileMenuToggle()"
                                                [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                              </div>
                                              <div class="tabcontent">
                                                <fieldset class="contenttabstyle">
                                                  <h2 class="tabcontentTitle">Videos</h2>
                                                  <!-- Tab Static Content -->
                                                  <div class="greytabtop">
                                                    <button [class.ViewModeHiddenElement]="_pageState == 1"
                                                      kendoButton
                                                      (click)="_openForm(_videosPageName)"
                                                      class="topRightButtonSecond">
                                                      Add Videos
                                                    </button>
                                                    <button [class.ViewModeHiddenElement]="_pageState == 1"
                                                      kendoButton
                                                      (click)="_selectVideosHandler($event)"
                                                      class="topRightButton">
                                                      Select from Library
                                                    </button>
                                                  </div>
                                                  <div class="tabcontent tabWizGridInside"
                                                    [class.ViewModeDisabledControl]="_pageState == 1">
                                                    <!-- [selectable]="true" -->
                                                    <asap-grid-layout [returnedSelectedKeys]="_selectedVideosKeys"
                                                      [pagingEnabled]="false"
                                                      [enableSiteSelection]="false"
                                                      [data]="_modelFilesVideo"
                                                      [isData]="true"
                                                      (doubleClickEvent)="_doDownloadVideo($event)"
                                                      class="gridWithcontent">
                                                      <ng-template pageListColumn
                                                        name="Name"
                                                        field="file.name"
                                                        let-item>
                                                        {{item.file.name}}
                                                      </ng-template>
                                                      <ng-template pageListColumn
                                                        name="Description"
                                                        field="file.description"
                                                        let-item>
                                                        {{item.file.description}}
                                                      </ng-template>
                                                      <ng-template pageListColumn
                                                        name="Type"
                                                        field="file.type"
                                                        let-item>
                                                        {{item.file.type}}
                                                      </ng-template>
                                                      <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                        <div class="asap-grid-remove" (click)="_removeVideoHandler(item)" [class.ViewModeHiddenElement]="_pageState == 1">
                                                          <div class="asap-grid-remove-icon">
                                                            <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                          </div>
                                                          <div class="asap-grid-remove-text">Delete</div>
                                                        </div>
                                                      </ng-template>
                                                    </asap-grid-layout>
                                                  </div>
                                                  <!-- Tab Custom Fields -->
                                                  <div class="tabcontent p-0">
                                                    <fieldset class="contenttabstyle margin-top-10">
                                                      <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                        [pageState]="_pageState"
                                                        [accounts]="_selectedAccountIds"
                                                        [formName]="'asset'"
                                                        page="asset-models"
                                                        [invalidSubmit]="_invalidSubmit"
                                                        (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                        (customFieldsDeleteValue)="_removeCustomField($event)"
                                                        (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                        (customFieldsStatus)="formStatus($event)"
                                                        [_customFieldsValue]="_customFieldsValue">
                                                      </asap-custom-fields-form>
                                                    </fieldset>
                                                  </div>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_addNewField(tab.id)">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                      </button>
                                                    </div>
                                                  </fieldset>
                                                </div>
                                              </ng-template>
                                            </kendo-tabstrip-tab>
                                          }
                                          <!-- Custom Tab -->
                                          @if (tab.isCustom) {
                                            <kendo-tabstrip-tab
                                              [disabled]="!_tabEnabled"
                                              [title]="tab.name">
                                              <ng-template kendoTabContent>
                                                <div class="tabcontent">
                                                  <fieldset class="contenttabstyle margin-top-10">
                                                    <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                      [pageState]="_pageState"
                                                      [accounts]="_selectedAccountIds"
                                                      [formName]="_entity"
                                                      [page]="_page"
                                                      [invalidSubmit]="_invalidSubmit"
                                                      (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                      (customFieldsDeleteValue)="_removeCustomField($event)"
                                                      (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                      (customFieldsStatus)="formStatus($event)"
                                                      (customForm)="getCustomForm($event)"
                                                      [_customFieldsValue]="_customFieldsValue">
                                                    </asap-custom-fields-form>
                                                    <div class="form-group special_style_formgroup">
                                                      <button kendobutton
                                                        class="addNewFieldButton k-button"
                                                        (click)="_addNewField(tab.id)">
                                                        <img class="backimage"
                                                          src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                        </button>
                                                      </div>
                                                      <div class="form-group special_style_formgroup">
                                                        <button kendobutton
                                                          class="addNewFieldButton k-button"
                                                          (click)="_deactivateTab(tab.id, _page)">
                                                          <img class="backimage"
                                                            src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                          </button>
                                                        </div>
                                                      </fieldset>
                                                    </div>
                                                  </ng-template>
                                                </kendo-tabstrip-tab>
                                              }
                                            }
                                          </kendo-tabstrip>
                                        </div>
                                        <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                                          @if (!_currentUser.isEnterprise) {
                                            <div
                                              class="borderedNotesContainer">
                                              <note #note
                                                [_pageState]="_pageState"
                                                [_model]="_model"
                                                [_page]="_page">
                                              </note>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                      <div class="row no_row_margin">
                                        <div class="col-12">
                                          <button kendobutton
                                            class="addNewtabButton k-button"
                                            (click)="_addNewTab()">
                                            <img class="backimage"
                                              src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                            </button>
                                          </div>
                                        </div>
                                        <div class="row no_row_margin">
                                          <div class="col-12">
                                            <button kendobutton
                                              class="reorderTabButton k-button"
                                              (click)="_reorderingtabs()">
                                              <img class="backimage"
                                                src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                              </button>
                                            </div>
                                          </div>
                                          <div class="row no_row_margin">
                                            <div class="col-12">
                                              <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                                Notes:
                                              </p>
                                              <p class="tabsMap">
                                                Tabs with <span>*</span> contains Mandatory fields
                                              </p>
                                              <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                                You can Drag and Drop Fields to reorder by clicking on this image
                                                <img class="reorder_image"
                                                  [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- Validation Summary -->
                                          <div class="row">
                                            <div class="col-12">
                                              @if (_invalidForm) {
                                                <asap-forms-validation-summary
                                                  [form]="_form"
                                                  [page]="_page"
                                                  [customValidation]="_customValidation">
                                                </asap-forms-validation-summary>
                                              }
                                            </div>
                                          </div>
                                          @if (  _editFormActive ||_orderingTabsForm || _deactivatedFieldsForm || _isEditForms || _showImagesGrid || _showDocumentGrid ||
                                            _selectModelTypeGridActive || isUPCResultEnabled || _selectCategoriesGridActive || _showVideoGrid || _selectSitesGridActive) {
                                            <div class="k-overlay"
                                            ></div>
                                          }
                                        </form>
                                        @if (_isDialiog) {
                                          <asap-dialog-layout
                                            [data]="_dialogModel"
                                            [componentName]="_dialogComponentName"
                                            (closeDialog)="_closeDialog($event)">
                                          </asap-dialog-layout>
                                        }
                                      </kendo-window>
                                    }
                                    @if (_selectSitesGridActive) {
                                      <kendo-window
                                        title="Select Site"
                                        (close)="_closeSitesList()"
                                        class="addFromLibrary">
                                        <div class="greytabtop">
                                          <button kendoButton
                                            class="topRightButtonSelect"
                                            (click)="_returnSelectedSitesHandler($event)">
                                            Select & Return
                                          </button>
                                        </div>
                                        <asap-grid-layout [selectable]="true"
                                          [singleSelect]="true"
                                          [groupingEnabled]="true"
                                          [pagingEnabled]="true"
                                          [headerEnable]="true"
                                          [headerTitle]="'Select Site'"
                                          [entityName]="_entity"
                                          [addNewFormEnabled]="false"
                                          [orderEnable]="true"
                                          [page]="_sitesPageName"
                                          [deletedEnabled]="false"
                                          [selectByField]="'id'"
                                          [selectByFieldTitle]="'Select Site'"
                                          [enableSiteSelection]="false"
                                          [filteringEnable]="true"
                                          [HideNotesFields]="true"
                                          [resolver]="_getSites"
                                          (onRowSelectionChanges)="_onSiteRowSelectionChanges($event)"
                                          (onRowObjectSelectionChanges)="_onSiteObjectRowSelectionChanges($event)">
                                          @for (column of _sitesGridFields; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                              @if (column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                            }
                                          }
                                        </asap-grid-layout>
                                      </kendo-window>
                                    }
                                    @if (_selectModelTypeGridActive) {
                                      <kendo-window
                                        title="Select Model Type"
                                        (close)="_closeModelTypeList()"
                                        class="addFromLibrary">
                                        <div class="greytabtop">
                                          <button kendoButton
                                            class="topRightButtonSelect"
                                            (click)="_returnSelectedModelTypeHandler($event)">
                                            Select & Return
                                          </button>
                                        </div>
                                        <asap-grid-layout [selectable]="true"
                                          [singleSelect]="true"
                                          [groupingEnabled]="true"
                                          [pagingEnabled]="true"
                                          [headerEnable]="true"
                                          [headerTitle]="'Select Type'"
                                          [entityName]="_entity"
                                          [addNewFormEnabled]="false"
                                          [orderEnable]="true"
                                          [page]="_modelTypePageName"
                                          [deletedEnabled]="false"
                                          [selectByField]="'id'"
                                          [selectByFieldTitle]="'Select Type'"
                                          [enableSiteSelection]="false"
                                          [filteringEnable]="true"
                                          [HideNotesFields]="true"
                                          [resolver]="_getModelTypes"
                                          (onRowSelectionChanges)="_onModelTypeRowSelectionChanges($event)"
                                          (onRowObjectSelectionChanges)="_onModelTypeObjectRowSelectionChanges($event)">
                                          @for (column of _modelTypesGridFields; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                              @if (column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                              on
                                            }
                                          }
                                          <!-- <ng-template pageListColumn name="Name" field="name" let-item>
                                          {{item.name}}
                                        </ng-template>
                                        <ng-template
                                          pageListColumn
                                          name="Description"
                                          field="description"
                                          let-item
                                          >
                                          {{item.description}}
                                        </ng-template>
                                        <ng-template pageListColumn name="Type" field="type" let-item>
                                          {{item.type}}
                                        </ng-template>
                                        <ng-template pageListColumn name="Stream" let-item>
                                          <img
                                            src="{{_storagePath + item.thumbnail}}"
                                            alt="{{ item.name }}"
                                            title="{{ item.name }}"
                                            width="50"
                                            />
                                          </ng-template> -->
                                        </asap-grid-layout>
                                        ou
                                        -w
                                      </kendo-window>
                                    }

                                    @if (_selectCategoriesGridActive) {
                                      <kendo-window
                                        title="Select Category"
                                        (close)="_closeCategoriesList()"
                                        class="addFromLibrary">
                                        <div class="greytabtop">
                                          <button kendoButton
                                            class="topRightButtonSelect"
                                            (click)="_returnSelectedCategoriesHandler($event)">
                                            Select & Return
                                          </button>
                                        </div>
                                        <asap-grid-layout [selectable]="true"
                                          [singleSelect]="true"
                                          [groupingEnabled]="true"
                                          [pagingEnabled]="true"
                                          [headerEnable]="true"
                                          [headerTitle]="'Select Category'"
                                          [entityName]="_entity"
                                          [addNewFormEnabled]="false"
                                          [orderEnable]="true"
                                          [page]="_categoriesPageName"
                                          [deletedEnabled]="false"
                                          [selectByField]="'id'"
                                          [selectByFieldTitle]="'Select Category'"
                                          [enableSiteSelection]="false"
                                          [filteringEnable]="true"
                                          [HideNotesFields]="true"
                                          [resolver]="_getCategories"
                                          (onRowSelectionChanges)="_onCategoryRowSelectionChanges($event)"
                                          (onRowObjectSelectionChanges)="_onCategoryObjectRowSelectionChanges($event)">
                                          @for (column of _categoriesGridFields; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                              @if (column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | dateFormat }}
                                                  }
                                                  @if (column.type != 'date') {
                                                    {{column.field | complexFieldValue: item}}
                                                  }
                                                </ng-template>
                                              }
                                            }
                                          }
                                        </asap-grid-layout>
                                      </kendo-window>
                                    }
                                    @if (_showImagesGrid) {
                                      <kendo-window
                                        title="Add Image(s) to asset model"
                                        (close)="_closeImagesWindow()"
                                        class="addFromLibrary">
                                        <div class="greytabtop">
                                          <button kendoButton
                                            class="topRightButtonSelect"
                                            (click)="_returnSelectedImagesHandler($event)">
                                            Select & Return
                                          </button>
                                          <!-- <input
                                          placeholder="Search..."
                                          [class.os-system]="_isOs"
                                          kendoTextBox
                                          #imageSearch
                                          [formControl]="_imageSearchControl"
                                          class="searchInput ml-2 rightSearchStyle col-6"
                                          spellcheck="false"
                                          /> -->
                                        </div>
                                        <asap-grid-layout [selectable]="true"
                                          [groupingEnabled]="true"
                                          [pagingEnabled]="true"
                                          [headerEnable]="true"
                                          [headerTitle]="'Select Image'"
                                          [entityName]="_entity"
                                          [addNewFormEnabled]="false"
                                          [orderEnable]="true"
                                          [page]="_filesPageName"
                                          [deletedEnabled]="false"
                                          [selectByField]="'id'"
                                          [searchResult]="_imageSearchResult"
                                          [selectedKeys]="_selectedImagesKeys"
                                          [selectByFieldTitle]="'Select Image'"
                                          [enableSiteSelection]="false"
                                          [filteringEnable]="true"
                                          [HideNotesFields]="true"
                                          [resolver]="_getAccountImages"
                                          (onRowSelectionChanges)="_onImageRowSelectionChanges($event)"
                                          (onRowObjectSelectionChanges)="_onImageObjectRowSelectionChanges($event)">
                                          @for (column of _filesGridFields; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  l
                                                  <!-- <ng-container *ngIf="column.field">
                                                  {{item[column.field]}}
                                                </ng-container> -->
                                                @if (column.type == 'date') {
                                                  {{ item[column.field] | dateFormat }}
                                                }
                                                @if (column.type != 'date' && column.field != 'thumbnail') {
                                                  {{column.field | complexFieldValue: item}}
                                                }
                                                @if (column.field == 'thumbnail') {
                                                  <img src="{{_storagePath + column.field | complexFieldValue: item}}"
                                                    alt="{{ item.name }}"
                                                    title="{{ item.name }}"
                                                    width="50" />
                                                  }
                                                </ng-template>
                                              }
                                              @if (column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  l
                                                  <!-- <ng-container *ngIf="column.field">
                                                  {{item[column.field]}}
                                                </ng-container> -->
                                                @if (column.type == 'date') {
                                                  {{ item[column.field] | dateFormat }}
                                                }
                                                @if (column.type != 'date' && column.field != 'thumbnail') {
                                                  {{column.field | complexFieldValue: item}}
                                                }
                                                @if (column.field == 'thumbnail') {
                                                  <img src="{{_storagePath + item.thumbnail}}"
                                                    alt="{{ item.name }}"
                                                    title="{{ item.name }}"
                                                    width="50" />
                                                  }
                                                </ng-template>
                                              }
                                              on
                                            }
                                          }
                                          <!-- <ng-template pageListColumn name="Name" field="name" let-item>
                                          {{item.name}}
                                        </ng-template>
                                        <ng-template
                                          pageListColumn
                                          name="Description"
                                          field="description"
                                          let-item
                                          >
                                          {{item.description}}
                                        </ng-template>
                                        <ng-template pageListColumn name="Type" field="type" let-item>
                                          {{item.type}}
                                        </ng-template>
                                        <ng-template pageListColumn name="Stream" let-item>
                                          <img
                                            src="{{_storagePath + item.thumbnail}}"
                                            alt="{{ item.name }}"
                                            title="{{ item.name }}"
                                            width="50"
                                            />
                                          </ng-template> -->
                                        </asap-grid-layout>
                                        ou
                                        -w
                                      </kendo-window>
                                    }
                                    @if (_showDocumentGrid) {
                                      <kendo-window
                                        title="Add Document(s) to asset model"
                                        (close)="_closeDocumentsWindow()"
                                        class="addFromLibrary">
                                        <div class="greytabtop">
                                          <button kendoButton
                                            class="topRightButtonSelect"
                                            (click)="_returnSelectedDocumentsHandler($event)">
                                            Select & Return
                                          </button>
                                          <!-- <input
                                          placeholder="Search..."
                                          [class.os-system]="_isOs"
                                          kendoTextBox
                                          #documentSearch
                                          [formControl]="_documentSearchControl"
                                          class="searchInput ml-2 rightSearchStyle col-6"
                                          spellcheck="false"
                                          /> -->
                                        </div>
                                        <asap-grid-layout [selectable]="true"
                                          [groupingEnabled]="true"
                                          [pagingEnabled]="true"
                                          [headerEnable]="true"
                                          [headerTitle]="'Select Document'"
                                          [entityName]="_entity"
                                          [addNewFormEnabled]="false"
                                          [orderEnable]="true"
                                          [page]="_documentsPageName"
                                          [deletedEnabled]="false"
                                          [selectByField]="'id'"
                                          [searchResult]="_documentSearchResult"
                                          [selectedKeys]="_selectedDocumentsKeys"
                                          [selectByFieldTitle]="'Select Document'"
                                          [enableSiteSelection]="false"
                                          [filteringEnable]="true"
                                          [HideNotesFields]="true"
                                          [resolver]="_getAccountDocuments"
                                          (onRowSelectionChanges)="_onDocumentsRowSelectionChanges($event)"
                                          (onRowObjectSelectionChanges)="_onDocumentObjectRowSelectionChange($event)">
                                          @for (column of _documentsGridFields; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  l
                                                  <!-- <ng-container *ngIf="column.field">
                                                  {{item[column.field]}}
                                                </ng-container> -->
                                                @if (column.type == 'date') {
                                                  {{ item[column.field] | dateFormat }}
                                                }
                                                @if (column.type != 'date') {
                                                  {{column.field | complexFieldValue: item}}
                                                }
                                              </ng-template>
                                            }
                                            @if (column.isTemplate) {
                                              <ng-template pageListColumn
                                                [field]="column.field"
                                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                [type]="column.type"
                                                let-item>
                                                l
                                                <!-- <ng-container *ngIf="column.field">
                                                {{item[column.field]}}
                                              </ng-container> -->
                                              @if (column.type == 'date') {
                                                {{ item[column.field] | dateFormat }}
                                              }
                                              @if (column.type != 'date') {
                                                {{column.field | complexFieldValue: item}}
                                              }
                                            </ng-template>
                                          }
                                          on
                                        }
                                      }
                                      <!-- <ng-template pageListColumn name="Name" field="name" let-item>
                                      {{item.name}}
                                    </ng-template>
                                    <ng-template
                                      pageListColumn
                                      name="Description"
                                      field="description"
                                      let-item
                                      >
                                      {{item.description}}
                                    </ng-template>
                                    <ng-template pageListColumn name="Type" field="type" let-item>
                                      {{item.type}}
                                    </ng-template> -->
                                  </asap-grid-layout>
                                </kendo-window>
                              }
                              @if (_showVideoGrid) {
                                <kendo-window
                                  title="Add Video(s) to asset"
                                  (close)="_closeVideosWindow()"
                                  class="addFromLibrary">
                                  <div class="greytabtop">
                                    <button kendoButton
                                      class="topRightButtonSelect"
                                      (click)="_returnSelectedVideosHandler($event)">
                                      Select & Return
                                    </button>
                                  </div>
                                  <asap-grid-layout [selectable]="true"
                                    [groupingEnabled]="true"
                                    [pagingEnabled]="true"
                                    [headerEnable]="true"
                                    [headerTitle]="'Select Video'"
                                    [entityName]="_entity"
                                    [addNewFormEnabled]="false"
                                    [orderEnable]="true"
                                    [page]="_videosPageName"
                                    [deletedEnabled]="false"
                                    [selectByField]="'id'"
                                    [searchResult]="_videoSearchResult"
                                    [selectedKeys]="_selectedVideosKeys"
                                    [selectByFieldTitle]="'Select Video'"
                                    [enableSiteSelection]="false"
                                    [filteringEnable]="true"
                                    [HideNotesFields]="true"
                                    [resolver]="_getAccountVideos"
                                    (onRowSelectionChanges)="_onVideosRowSelectionChanges($event)"
                                    (onRowObjectSelectionChanges)="_onVideoObjectRowSelectionChange($event)">
                                    @for (column of _videosGridFields; track column) {
                                      @if (column.selected) {
                                        @if (!column.isTemplate) {
                                          <ng-template pageListColumn
                                            [field]="column.field"
                                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                            [type]="column.type"
                                            let-item>
                                            l
                                            <!-- <ng-container *ngIf="column.field">
                                            {{item[column.field]}}
                                          </ng-container> -->
                                          @if (column.type == 'date') {
                                            {{ item[column.field] | dateFormat }}
                                          }
                                          @if (column.type != 'date') {
                                            {{column.field | complexFieldValue: item}}
                                          }
                                        </ng-template>
                                      }
                                      @if (column.isTemplate) {
                                        <ng-template pageListColumn
                                          [field]="column.field"
                                          [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                          [type]="column.type"
                                          let-item>
                                          l
                                          <!-- <ng-container *ngIf="column.field">
                                          {{item[column.field]}}
                                        </ng-container> -->
                                        @if (column.type == 'date') {
                                          {{ item[column.field] | dateFormat }}
                                        }
                                        @if (column.type != 'date') {
                                          {{column.field | complexFieldValue: item}}
                                        }
                                      </ng-template>
                                    }
                                  }
                                }
                              </asap-grid-layout>
                            </kendo-window>
                          }
                          @if (_deactivatedFieldsForm) {
                            <kendo-window
                              title="Deactivated Fields"
                              (close)="_closeInactiveFields()">
                              <div class="row no_row_margin margin-top-30">
                                <div class="col-12 margin-top-10">
                                  <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                    <kendo-grid-column field="name" title="Fields Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="formTab.name" title="Tab Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.createdOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="lastUpdatedOn"
                                      title="Deactivation Date"
                                      type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastUpdatedOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="Command" title="Command">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <div class="action-button action-button-deactivate"
                                          (click)="_reactivateField(dataItem)">
                                          <div class="action-button-icon">
                                            <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                          </div>
                                          <div class="edit-icon-text">Reactivate</div>
                                        </div>
                                      </ng-template>
                                    </kendo-grid-column>
                                  </kendo-grid>
                                </div>
                              </div>
                            </kendo-window>
                          }
                          @if (_editFormActive) {
                            <kendo-window
                              [resizable]="false"
                              title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                              (close)="_closeCustomFields()"
                              class="customFieldsWindow">
                              <asap-custom-fields [accounts]="_selectedAccountIds"
                                [tabGroup]="_selectedTabId"
                                [labelId]="_selectedLabelId"
                                [labelObjectCode]="_selectedLabelObjectCode"
                                [formName]="_entity"
                                [page]="_page"
                                [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                [isCustomtabsForm]="_isAddTabFormValue"
                                [isRenameForm]="_isRenameFormValue"
                                [language]="_language"
                                [isRenameCustomForm]="_isRenameCustomFormValue"
                                [isRenameLabel]="_isRenameLabel"
                                [isMandatory]="_isMandatory"
                                (closePopup)="ClosePopup($event)"
                                [permissionScope]="_permissionScope">
                              </asap-custom-fields>
                            </kendo-window>
                          }
                          @if (_orderingTabsForm) {
                            <kendo-window
                              title="Tab Reordering"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="_closeOrderingTabsForm()">
                              <div class="row no_row_margin margin-top-30">
                                @if (false) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab 1</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [valueField]="'name'"
                                        placeholder="Accounts/Sites"
                                        class="newFormControlWidth disabled">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                                @for (item of _dataTabs ; track item; let i = $index) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [textField]="'name'"
                                        [valueField]="'name'"
                                        [placeholder]="item.name"
                                        required
                                        class="bordered newFormControlWidth"
                                        (valueChange)="_comboValueChange($event,i)">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="row no_row_margin">
                                <div class="col-12">
                                  <button kendoButton
                                    class="steps_buttons_class"
                                    (click)="_onSaveTabOrdering()">
                                    <img class="backimage"
                                      [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                      <span>save & Close</span>
                                    </button>
                                  </div>
                                </div>
                              </kendo-window>
                            }
                            @if (_isEditForms) {
                              <asap-edit-forms
                                (close)="_onCloseEditForms($event)"
                                (saved)="_closeCustomFields()"
                                [page]="_page"
                                [permissionScope]="_permissionScope">
                              </asap-edit-forms>
                            }

                            @if (isUPCResultEnabled) {
                              <kendo-window
                                title="Add UPC Data To Model"
                                (close)="_closeUpcWindow()"
                                class="addFromLibrary">
                                <div class="greytabtop">
                                  <button kendoButton
                                    class="topRightButtonSelect"
                                    (click)="_returnSelectedUPCItem()">
                                    Select & Return
                                  </button>
                                </div>
                                <kendo-grid [data]="_upcResult" [scrollable]="'none'"
                                  [selectable]="true"
                                  (selectionChange)="_selectUPCItem($event)">
                                  <kendo-grid-checkbox-column></kendo-grid-checkbox-column>
                                  <kendo-grid-column field="title" title="Name" [editable]="false">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="description"
                                    title="Description"
                                    [editable]="false">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="price" title="Cost" [editable]="false">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="manufacturer"
                                    title="Manufacturer"
                                    [editable]="false">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="total" title="Total" [editable]="false">
                                  </kendo-grid-column>
                                </kendo-grid>
                              </kendo-window>
                            }
                            <!-- <div class="k-overlay"
                          *ngIf="  _editFormActive ||_orderingTabsForm || _deactivatedFieldsForm || _isEditForms || _showImagesGrid || _showDocumentGrid"></div> -->
